import { IExtendedContext } from '../../../types/extendedContext';
import { checkService } from '../../../../shared/ServicePickerWidget/thunks/checkout/checkService';

export const recheckServicesAvailabilityHandler = (context: IExtendedContext) => () => {
  context.store.dispatch(checkService());
};
